<template>
    <div v-if="$consentGiven == 'accepted'" class="homepage-container">
      <h1>Vul hier jouw Knalbak in</h1>
      <div class="kenteken-container">
        <div class="kenteken-blauw"></div>
        <!-- Input field for the license plate -->
        <input v-on:keyup.enter="goToKenteken" maxlength="8" type="text" ref="license_input" class="kenteken-input" v-model="license_input" @input="format_license()"/></div>
      <button @click="goToKenteken" :class="['blue-button', { disabled: !license_input }]" >Beoordelen</button>
    </div>
    <!-- List for the top 10 items -->
    <div class="best-container">
      <h2>Top 10 knalbakken van {{ currentMonth }}</h2>
      <div v-if="top10Items" class="best-list">
        <div class="best-item" v-for="item in top10Items" :key="item.kenteken">
          <div class="best-top">
            <p class="best-kenteken">{{ item.kenteken }}</p>
            <p class="best-info">{{ item.kenteken_data.merk }}</p>
            <p class="best-info">{{ item.kenteken_data.handelsbenaming }}</p>
            <p class="best-info">{{ item.kenteken_data.datum_eerste_toelating }}</p>
          </div>
          <div class="best-bottom">
            <p class="best-kenteken">{{ item.aantal_stemmen }} Stem<span v-if="item.aantal_stemmen > 1">men</span></p>
            <p class="best-info">Gemiddelde score</p>
            <div class="range-container">
              <div class="range-score" :style="{marginLeft: item.gemiddelde_score * 3 + 'px'}">
                <div class="range-number">
                  <p>{{ item.gemiddelde_score / 10 }}</p>
                </div>
                <div class="range-pointer"></div>
              </div>
              <div class="range-bar">
                <div class="range-white"></div>
                <div class="range-yellow" :style="{width: item.gemiddelde_score * 3 + 'px'}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="loading-cover loading-home" v-else>
        <img alt="loading" src="../assets/img/wheel2.svg" width="200px" height="200px" >
      </div>
    </div>

</template>
  

  <script>
  import config from '../../config.js';
  import axios from 'axios'

  function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
  }
  export default {
    name: 'HomePage',
    data() {
      return {
        license_input: '',
        top10Items: null,
        Months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        currentMonth: null,
      }
    },

    methods: {
      // Vue router function to search for a license plate
      goToKenteken() {
        if (this.license_input.trim()) {
          this.$router.push({ name: 'viewKenteken', params: { kentekennum: this.license_input.trim() } })
        }
      },
      // Fetch data for the top 10 list
      async fetchData() {
        {
          const response = await axios.post(`${config.server_url}db_scripts/get/gettop10.php`, {});
          for (let index = 0; index < response.data.length; index++) {
            response.data[index].kenteken_data = JSON.parse(response.data[index].kenteken_data)
          }
          this.top10Items = response.data
        }
      },
      format_license: function(input = null) {
        var self = this;
        var original_value = input !== null ? input : self.license_input;

        // Zorg dat het een string is
        if (typeof original_value !== 'string') {
            original_value = String(original_value || '');
        }

        var tmp = original_value.replaceAll(" ", "");
        var i = 0;
        var total_kenteken = "";

        while (typeof tmp[i] !== "undefined") {
            var count1 = (total_kenteken.match(/-/g) || []).length;
            if (
                typeof tmp[i + 1] !== "undefined" &&
                isNumeric(tmp[i]) !== isNumeric(tmp[i + 1]) &&
                tmp[i] !== "-" &&
                tmp[i + 1] !== "-" &&
                count1 < 2
            ) {
                total_kenteken += tmp[i] + "-";
            } else {
                total_kenteken += tmp[i];
            }
            i++;
        }

        var count2 = (total_kenteken.match(/-/g) || []).length;
        if (count2 < 2) {
            var i2 = 0;
            tmp = total_kenteken.split("-");
            while (typeof tmp[i2] !== "undefined") {
                if (tmp[i2].length === 4) {
                    total_kenteken = total_kenteken.replaceAll(
                        tmp[i2],
                        tmp[i2][0] + tmp[i2][1] + "-" + tmp[i2][2] + tmp[i2][3]
                    );
                }
                i2++;
            }
        }

        if (total_kenteken.startsWith("-")) {
            total_kenteken = total_kenteken.slice(1);
        }

        tmp = total_kenteken.split("-");
        if (tmp.length >= 4) {
            total_kenteken = tmp[0] + "-" + tmp[1] + "-";
            i = 2;
            while (typeof tmp[i] !== "undefined") {
                total_kenteken += tmp[i];
                i++;
            }
        }

        total_kenteken = total_kenteken.toUpperCase();

        if (input === null && total_kenteken !== original_value) {
            self.license_input = total_kenteken;
        }

        return total_kenteken;
      }

    },
    // When the app is mounted get the data and focus on the input field
    mounted() {
      this.currentMonth = this.Months[new Date().getMonth()];
      if (this.$consentGiven == 'accepted') {
        this.$refs.license_input.focus();        
      }
      this.fetchData();
    }
  }
  </script>
  
<style scoped>
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .homepage-container {
    display: flex;
    margin-top: 200px;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .homepage-container h1 {
    text-align: center;
    font-size: 64px;
  }

  .kenteken-container {
    display: flex;
    flex-direction: row;
  }

  .kenteken-blauw {
    border-radius: 6px 0px 0px 6px;
    width: 50px;
    background-image: url('../assets/img/eu.webp');
    background-size: auto 60%;
    background-repeat: no-repeat;
    background-position: center;
    padding: 10px;
    background-color: var(--license-blue);
  }

  .kenteken-input {
    padding: 20px 20px;
    background-color: var(--license-yellow);
    border-width: 0;
    border-radius: 0px 6px 6px 0px;
    font-family: arial;
    font-size: 64px;
    font-weight: bold;
    text-align: center;
    width: 355px;
    text-transform: uppercase;
  }

  .kenteken-input:focus {
    outline: none;
  }

  .kenteken-input::selection {
    display: none;
  }

  .best-container {
    padding-top: 200px;
    display: flex;
    flex-direction: column;
    gap: 50px;
    align-items: center;
  }
  
  .best-container h2 {
    font-size: 48px;
    font-weight: 700;
    text-align: center;
    width: 80%;
  }

  .best-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 50px;
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-timing-function: linear;
  }

  .best-item {
    display: flex;
    flex-direction: column;
    width: 500px;
  }

  .best-top {
    gap: 10px;
    justify-content: center;
    border-radius: 6px 6px 0px 0px;
    background-color: var(--license-yellow);
    padding: 10px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000;
  }

  .best-bottom {
    color: #fff;
    gap: 10px;
    border-radius: 0px 0px 6px 6px;
    background-color: var(--license-blue);
    padding: 10px 0px 30px 0px;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .best-kenteken {
    font-size: 40px;
    font-weight: bold;
  }
  
  .best-info, .best-kenteken {
    font-family: outfit,  arial;
  }

  .best-info {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    text-wrap: balance;
  }

  .range-container {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  .range-bar {
    width: 300px;
  }

  .range-white {
    background-color: #fff;
    width: 300px;
    height: 10px;
    border-radius: 5px;
    position: absolute;
    z-index: 2;
  }

  .range-yellow {
    z-index: 3;
    position: absolute;
    background-color: var(--license-yellow);
    height: 10px;
    border-radius: 5px;
  }

  .range-score {
    width: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: -5px;
    z-index: 1;
  }

  .range-number {
    background-color: #fff;
    border-radius: 6px;
    width: 60px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .range-number p {
    color: var(--license-blue);
    font-size: 32px;
    font-family: outfit,  arial;
    font-weight: bold;
  }

  .range-pointer {
    width: 30px;
    height: 30px;
    background-color: #fff;
    clip-path: polygon(50% 100%, 0 0, 100% 0);
  }
  
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media only screen and (max-width: 760px) {

    .homepage-container {
      margin: 150px 0px;
    }

    .homepage-container h1 {
      font-size: 48px;
    }

    .kenteken-blauw {
      width: 25px;
    }

    .kenteken-input {
      width: 250px;
      padding: 10px 10px;
      background-color: var(--license-yellow);
      border-width: 0;
      font-size: 48px;
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
    }

    .best-list {
      height: 600px;
      overflow-y: scroll;
      background-color: #fff;
      border-radius: 6px;
      padding: 20px 0px;
      width: 85%;
    }

    .best-item {
      width: 300px;
    }

    .range-container {
      scale: 0.8;
    }

  }

  @media only screen and (max-width: 1024px) and (min-width: 760px) {
    .best-item {
      width: 400px;
    }
  }

</style>
